import { createMuiTheme } from '@material-ui/core/styles';

export const commonTheme = createMuiTheme({
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "*, *::before, *::after": {
          boxSizing: "content-box",
        },

        body: {
          color: "#232323",
          backgroundColor: "#fff"
        },
      },
    },
    MuiTab: {
      root: {
        fontSize: "16px",
        fontFamily: "Open Sans",
        "&.MuiTab-root": {
          border: 0,
          "&:hover": {
            border: 0,
          },
        },
      }
    },
    MuiTableCell: {
      head: {
        color: "#077F83",
        borderBottom: "1px solid lightgrey",
      },
      body: {
        padding: "8px 16px",
        lineHeight: "1.50",
        '& .MuiIconButton-root': {
          padding: "0px 16px",
        }
      },
      root: {
        fontSize: "16px",
        fontFamily: "Open Sans",
      },

    },
    MuiStepper: {
      root: {
        padding: "0px",
      },
    },
    MuiStep: {
      root: {
        width: "100%",
        border: "1px solid rgb(7, 127,131)",
        padding: "10px",
        margin: "2px",
      },
      completed: {
        backgroundColor: "rgb(7, 127,131)",
      },

    },
    MuiStepLabel: {
      label: {
        color: "rgb(7, 127,131)",
        fontWeight: "normal",
        fontSize: "10px",
      },
      active: {
        color: "white !important",
      },
      completed: {
        color: "white !important",
      },
    },
    MuiStepIcon: {
      root: {
        color: "rgb(7, 127,131)",
      },
      completed: {
        color: "white !important",
      },
      active: {
        color: "white !important",
      },
      text: {
        fill: "black",
      },
    },
    MuiFormControl: {
      root: {
        width: "100%",
      },
    },
    MuiChip: {
      root: {
        borderRadius: '0px',
        height: '27px'
      },
      deleteIcon: {
        color: 'black',
        height: '15px'
      },
      deleteIconOutlinedColorPrimary: {
        variant: 'outlined'
      }
    },
    MuiDialogTitle:{
      root:{
        "& h6":{
          color:" rgb(99,101,105)",
          fontWeight:"bold" ,
          fontFamily:"Open Sans"     
        }
      }
    }
  },
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: "#077F83",
      light: "#077f837a",
      contrastText: "#fff"
    },
    secondary: {
      // This is green.A700 as hex.
      main: '#EF7000',
      light: "#3B86FF"
    },

  },
  typography: {
    h1: {
      fontSize: "24px",
      fontFamily: "Lato",
      // lineHeight: "27px",
    },
    subtitle1: {
      fontSize: "18px",
      fontFamily: "Open Sans",
      fontWeight: 800,
    },
    h2: {
      fontSize: "15px",
      fontFamily: "Open Sans",
    },
    h3: {
      fontSize: "14px",
      fontFamily: "Open Sans",
    },
    button: {
      fontSize: "14px",
      fontFamily: "Open Sans",

    },
  },



});

// .wrapper {
//     color: "#232323";
//     font-family: "Calibri";
//     background-color: "#F9FAFE";
// }

// .h1 {
//     font-size: 22px !important;
//     line-height: 27px !important
// }

// .h2 {
//     font-size: 20px !important;
//     line-height: 25px !important;
// }

// .h3 {
//     font-size: 18px !important;
//     line-height: 23px !important;
// }

// .h4 {
//     font-size: 16px !important;
//     line-height: 20px !important;
// }

// .h5 {
//     font-size: 15px !important;
//     line-height: 25px !important;
// }

// .h6 {
//     font-size: 12px !important;
//     line-height: 15px !important;
// }

// .h7 {
//     font-size: 11px !important;
//     line-height: 18px !important;
// }import CustomInput from './Components/CustomInput';


// .fontCalibri {
//     font-family: "Calibri";
// }

// .fontNormal {
//     font-weight: "300";
// }

// .fontSemiBold {
//     font-weight: "500";
// }

// .fontBold {
//     font-weight: "700";
// }